export const GROUP = '/group/' as const
export const GROUP_ALL = `${GROUP}all` as const
export const GROUP_ALL_SHORT = `${GROUP_ALL}/short` as const
export const GROUP_ALL_UPDATED = `${GROUP_ALL}/updated` as const
export const GROUP_ASSIGN = `${GROUP}assign` as const
export const GROUP_GROUPING = `${GROUP}grouping` as const
export const GROUP_SHUFFLE = `${GROUP}shuffle` as const
export const GROUP_STUDENT_TRANSFER = `${GROUP}student/transfer` as const
export const GROUP_GENERATE_STUDENT_LIST = `${GROUP}generate/student/list` as const
